import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="w-full min-h-screen bg-white" data-id="element-312">
      <Navbar data-id="element-313" />
      <HeroSection data-id="element-314" />
      <AboutSection data-id="element-315" />
      <ServicesSection data-id="element-316" />
      <ResourcesSection data-id="element-317" />
      <TestimonialsSection data-id="element-318" />
      <ContactSection data-id="element-319" />
      <Footer data-id="element-320" />
    </div>;
}